import script from "./AppTop.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTop.vue?vue&type=script&setup=true&lang=js"

import "./AppTop.vue?vue&type=style&index=0&id=0dd2de2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd2de2a"]])

export default __exports__